// Services
export * from './filter.service';
export * from './form-management.service';
export * from './search-pagination.service';
export * from './selection.service';

// Utilities
export * from './validation.utils';

// Re-export interfaces to avoid conflicts
export type { NamedId, SelectionState } from './selection.service';

export interface LoadItemsEvent {
  pagination?: {
    search?: string;
    limit?: number;
    page?: number;
  };
  filters?: any[];
}
